import { MouseEvent } from 'react';

import { updateCart } from 'common/actions/cartActions';
import { klaviyoAddedEvent, productAddedEvent } from 'common/models/TrackingEvents';
import { cart } from 'helpers/routes';
import timerQueue, { EventType } from 'helpers/TimerQueue';
import { getKlaviyoAddProductData } from 'helpers/tracking/data/getKlaviyoProductTrackingData';
import { getProductTrackingData } from 'helpers/tracking/data/getProductTrackingData';
import { track } from 'helpers/tracking/tracking';
import { ProductDetailsPageProps } from 'store/appContext';

import { SelectorOption } from '../types/SelectorOption';

export const getAddToCart = ({
  currencySymbol,
  localized,
  productDetails: { product, userFacingDepartment },
  selectedSize,
}: {
  currencySymbol: string;
  localized: (url?: string) => string;
  productDetails: ProductDetailsPageProps;
  selectedSize: {
    selected?: string;
    selectedOption?: SelectorOption;
    showSelectSizeBadge: boolean;
  };
}): { addToCart: (e: MouseEvent<HTMLElement>) => void } => {
  return {
    addToCart: e => {
      e.preventDefault();
      updateCart(selectedSize.selected, 1, () => {
        timerQueue.addEvent({
          callback: () =>
            track(
              productAddedEvent,
              getProductTrackingData(product, currencySymbol, {
                selectedSize: selectedSize.selected,
                userFacingDepartment,
              }),
            ),
          type: EventType.UserEvent,
        });
        timerQueue.addEvent({
          callback: () => track(klaviyoAddedEvent, getKlaviyoAddProductData(product)),
          type: EventType.UserEvent,
        });
        timerQueue.addEvent({
          callback: () => {
            window.location.href = localized(cart);
          },
          type: EventType.Navigation,
        });
      });
    },
  };
};
